
import MyCstmrList from '@/views/myCstmr/MyCstmrList'
import MyCstmrView from '@/views/myCstmr/MyCstmrView'
import MyCstmrReg from '@/views/myCstmr/MyCstmrReg'
import MyCstmrRegResult from '@/views/myCstmr/MyCstmrRegResult'
import CstmrRegByCstmr from '@/views/myCstmr/CstmrRegByCstmr'
import CstmrRegByCstmrExpired from '@/views/myCstmr/CstmrRegByCstmrExpired'
import CstmrRegByCstmrComplete from '@/views/myCstmr/CstmrRegByCstmrComplete'
import CstmrRegByCstmrResult from '@/views/myCstmr/CstmrRegByCstmrResult'
import SmsSend from '@/views/myCstmr/SmsSend'
import DetailSearch from '@/views/myCstmr/DetailSearch'
import ProdSearch from '@/views/myCstmr/ProdSearch'
import InterestInfo from '@/views/myCstmr/InterestInfo'
import Memo from '@/views/myCstmr/Memo'
import FamilyInfo from '@/views/myCstmr/FamilyInfo'
import BuyInfo from '@/views/myCstmr/BuyInfo'
import PopAgreeInfo from '@/views/myCstmr/PopAgreeInfo'
import AddChildren from '@/views/myCstmr/AddChildren'
import RecruitInfo from '@/views/myCstmr/RecruitInfo'
import CstIntegration from '@/views/myCstmr/CstIntegration'
import ModifyChildren from '@/views/myCstmr/ModifyChildren'
import ModifyMemo from '@/views/myCstmr/ModifyMemo'
import CounselLog from '@/views/myCstmr/CounselLog'
import CounselView from '@/views/myCstmr/CounselView'

export default [
    {
        path: '/myCstmr/myCstmrList',
        name: 'my-cstmr-list',
        component: MyCstmrList,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '고객목록', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView',
        name: 'my_cstmr-view',
        component: MyCstmrView,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '고객상세', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrList/smsSend',
        name: 'my-cstmr-sms-send',
        component: SmsSend,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: 'SMS발송', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrList/detailSerach/:listTyp?',
        name: 'my-cstmr-detail-search',
        component: DetailSearch,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          path: '/myCstmr/myCstmrList/detailSerach',
          pageName: '상세검색팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrList/proddSerach',
        name: 'prod-search',
        component: ProdSearch,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '상품검색팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/interestInfo',
        name: 'interest-info',
        component: InterestInfo,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '관심및무진정보', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrReg',
        name: 'my-cstmr-reg',
        component: MyCstmrReg,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '고객등록', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrReg/myCstmrRegResult',
        name: 'my-cstmr-reg-result',
        component: MyCstmrRegResult,
        meta: {
          auth: false,
          logging: false, // 로깅 여부
          pageName: '등록결과', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrReg/cstmrRegByCstmr',
        name: 'cstmr-reg-by-cstmr',
        component: CstmrRegByCstmr,
        meta: {
          auth: false,
          logging: true, // 로깅 여부
          pageName: '고객직접등록', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrReg/cstmrRegByCstmrExpired',
        name: 'cstmr-reg-by-cstmr-expired',
        component: CstmrRegByCstmrExpired,
        meta: {
          auth: false,
          logging: false, // 로깅 여부
          pageName: '고객직접등록-만료', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrReg/cstmrRegByCstmrComplete',
        name: 'cstmr-reg-by-cstmr-complete',
        component: CstmrRegByCstmrComplete,
        meta: {
          auth: false,
          logging: false, // 로깅 여부
          pageName: '고객직접등록-완료', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrReg/cstmrRegByCstmrResult',
        name: 'cstmr-reg-by-cstmr-result',
        component: CstmrRegByCstmrResult,
        meta: {
          auth: false,
          logging: false, // 로깅 여부
          pageName: '고객직접등록결과', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/memo',
        name: 'my-cstmr-memo',
        component: Memo,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '메모팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/familyInfo',
        name: 'family-info',
        component: FamilyInfo,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '가구화정보팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/CounselLog',
        name: 'counsel_log',
        component: CounselLog,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '상담일지팝업', // 로깅 시 사용할 페이지명
      }
    },    
    {
        path: '/myCstmr/myCstmrView/CounselView',
        name: 'counsel_View',
        component: CounselView,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '상담리포트미리보기', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/buyInfo',
        name: 'buy-info',
        component: BuyInfo,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '구매이력보기팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/popAgreeInfo',
        name: 'pop-agree-info',
        component: PopAgreeInfo,
        meta: {
          auth: false,
          logging: false, // 로깅 여부
          pageName: '개인정보 수집 및 이용동의 마케팅 목적 활동 동의 안내 팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/addChildren',
        name: 'add-children',
        component: AddChildren,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '자녀추가', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/recruitInfo',
        name: 'recruit-info',
        component: RecruitInfo,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '기존리크루팅보기팝업', // 로깅 시 사용할 페이지명
      }
    },
    {
      path: '/myCstmr/CstIntegration',
      name: 'cst-integration',
      component: CstIntegration
      ,
      meta: {
        auth: true,
        logging: true, // 로깅 여부
        pageName: '고객통합', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/modifyChildren',
        name: 'modify-children',
        component: ModifyChildren,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '자녀수정', // 로깅 시 사용할 페이지명
      }
    },
    {
        path: '/myCstmr/myCstmrView/modifyMemo',
        name: 'my-cstmr-modify-memo',
        component: ModifyMemo,
        meta: {
          auth: true,
          logging: true, // 로깅 여부
          pageName: '메모수정팝업', // 로깅 시 사용할 페이지명
      }
    },
]